import { Controller } from "@hotwired/stimulus"

// Submits the controller's form when an input changes, replacing inline
// onchange="this.form.submit()" handlers (which an enforcing CSP blocks as
// script-src-attr). Attach to the form and wire each control with
// data-action="change->auto-submit#submit".
export default class extends Controller {
  submit(event) {
    const form = event.target.form || this.element.closest("form")
    if (form) form.requestSubmit()
  }
}
